import Cookies from 'universal-cookie'

const cookies = new Cookies();
 
class Auth {
    isSign() {
        const token = cookies.get('token');

        if (token === undefined || token === '') {
            return false;
        }
        else {
            return true;
        }
    }

    signOut() {
        console.log("sign out")
        cookies.remove('token');

    }

    options() {
        const token = cookies.get('token');

        var auth = 'Bearer ' + token;

        return {
            'Authorization': auth
        };
    }

    token() {

        const token = cookies.get('token');
        return token;

    }

    unionId() {
        return cookies.get('unionId');
    }

    openId() {
        return cookies.get('openId');
    }
}

export default Auth